import React, { useState } from "react";
import { Box, IconButton, Menu } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CustomChip from "../shared/CustomChip"; 
import { snakeCaseToTitleCase } from "../utils/CaseFormatHelper"; 

interface SupplyRequestsElementProps {
  currentStatus: string;
  onStatusChange: (event: any, status: string) => void;
}

const SupplyRequestsElement: React.FC<SupplyRequestsElementProps> = ({ currentStatus, onStatusChange }) => {
  const statuses = ["new", "completed", "canceled"];
  
  const orderedStatuses = [
    currentStatus,
    ...statuses.filter((status) => status !== currentStatus),
  ];

  // Using anchorEl for the Menu instead of open/close for Collapse
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleToggle = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation(); // Prevents table row clicks from interfering
    if (open) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = (event: any) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const getChipColor = (status: string) => {
    switch (status) {
      case "completed":
        return "success";
      case "canceled":
        return "error";
      case "new":
        return "warning";
      default:
        return "info";
    }
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      {/* The main button that triggers the menu */}
      <Box
        sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        onClick={handleToggle}
      >
        <IconButton size="small" sx={{ pointerEvents: "none" }}>
          {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
        <Box sx={{ pointerEvents: "none", minWidth: 92 }}>
          <CustomChip
            label={snakeCaseToTitleCase(currentStatus)}
            type={getChipColor(currentStatus)}
            fullWidth
          />
        </Box>
      </Box>

      {/* The portal Menu that will never get clipped by the table */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          elevation: 3,
          sx: { mt: 1, p: 1, borderRadius: 2 }
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, px: 1 }}>
          {orderedStatuses?.map((status) => (
            <Box
              key={status}
              sx={{ minWidth: 92 }}
              onClick={(e: any) => {
                e.stopPropagation();
                if (status !== currentStatus) {
                  onStatusChange(e, status);
                }
                setAnchorEl(null);
              }}
            >
              <CustomChip
                label={snakeCaseToTitleCase(status)}
                type={status === currentStatus ? "info" : getChipColor(status)}
                fullWidth
              />
            </Box>
          ))}
        </Box>
      </Menu>
    </Box>
  );
};

export default SupplyRequestsElement;